enum PrinterDestination {
  Receipt = 0,
  Kitchen = 1,
  Test = 2,
}

export { PrinterDestination };
